import { occupationEntityName } from '@juvare/credentialing/backend/config/shared';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
export const useOccupationIdNameMap = ({ occupationIds = [] }) => {
    var _a;
    const { data: occupations } = useStorageList(occupationEntityName, {
        filter: [
            {
                id: occupationIds,
                op: 'in',
            },
        ],
    });
    const occupationIdNameMap = (_a = occupations === null || occupations === void 0 ? void 0 : occupations.rows.reduce((idNameMap, occupation) => {
        idNameMap[occupation.id] = occupation.columns.name;
        return idNameMap;
    }, {})) !== null && _a !== void 0 ? _a : {};
    return occupationIdNameMap;
};
